export default __webpack_public_path__ + "static/media/nav-toggle.13fe6d22.svg";